import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Gift, Sparkles, X } from 'lucide-react';
import { Button } from './ui/button';
import { referralsAPI } from '../api';

const ViralReferralBanner = () => {
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [dismissed, setDismissed] = useState(
    typeof window !== 'undefined' && sessionStorage.getItem('viral_banner_dismissed') === '1'
  );

  useEffect(() => {
    if (dismissed) return;
    (async () => {
      try {
        const res = await referralsAPI.me();
        setInfo(res.data);
      } catch (e) { /* ignore */ }
    })();
  }, [dismissed]);

  if (dismissed || !info || (info.referrals_count || 0) > 0) return null;

  const dismiss = () => {
    sessionStorage.setItem('viral_banner_dismissed', '1');
    setDismissed(true);
  };

  const share = () => {
    const url = `${window.location.origin}/signup?ref=${info.code}`;
    const text = `Renta autos con $200 MXN de descuento. Usa mi código: ${info.code}`;
    if (navigator.share) {
      navigator.share({ title: 'Mobility', text, url });
    } else {
      navigator.clipboard.writeText(`${text}\n${url}`);
      navigate('/profile');
    }
  };

  return (
    <div
      className="relative bg-gradient-to-r from-purple-600 via-blue-600 to-purple-600 text-white rounded-xl p-5 mb-6 shadow-lg overflow-hidden"
      data-testid="viral-banner"
    >
      <button
        onClick={dismiss}
        className="absolute top-2 right-2 p-1 hover:bg-white/10 rounded transition"
        aria-label="Cerrar"
        data-testid="viral-banner-dismiss"
      >
        <X className="w-4 h-4" />
      </button>
      <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
        <div className="flex-shrink-0 bg-white/10 p-3 rounded-full">
          <Gift className="w-6 h-6" />
        </div>
        <div className="flex-1">
          <h3 className="font-bold text-lg flex items-center gap-1.5">
            Comparte y gana <Sparkles className="w-4 h-4" />
          </h3>
          <p className="text-sm text-white/90 mt-0.5">
            Tu código <code className="bg-white/20 px-2 py-0.5 rounded font-mono">{info.code}</code> da
            <strong> $200 MXN</strong> a tus amigos y <strong>$100 MXN</strong> a ti.
          </p>
        </div>
        <Button
          onClick={share}
          className="bg-white text-purple-700 hover:bg-gray-100 font-semibold whitespace-nowrap"
          data-testid="viral-banner-share-btn"
        >
          Compartir código
        </Button>
      </div>
    </div>
  );
};

export default ViralReferralBanner;
